import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import TabBar from '@alltrails/shared/denali/components/TabBar';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import ListDropdown from '@alltrails/shared/components/ListDropdown';
import Chevron from '@alltrails/shared/icons/Chevron';
import { COLOR_INTERACTIVE_SUBTLE } from '@alltrails/shared/denali/tokens';
import Button from '@alltrails/shared/denali/components/Button';
import * as styles from './styles/styles.module.scss';
import navScrollTo from './navScrollTo';
import { NavItem } from './types/NavItem';

export type ScrollerNavProps = {
  items: NavItem[];
  title: string;
  selectedTab: string;
  onTabChange: (id: string) => void;
  // eslint-disable-next-line react/require-default-props
  ctaInfo?: {
    title: string;
    onClick?: () => void;
  };
};

const ScrollerNav = ({ items, title, selectedTab, onTabChange, ctaInfo }: ScrollerNavProps): JSX.Element => {
  const location = useLocation();
  const shouldCollapseNav = useMediaQuery(`(max-width:1024px)`);
  const [showDropdown, setShowDropdown] = useState<boolean>(false);

  const handleTabChange = (id: string) => {
    navScrollTo(id);
    onTabChange(id);
    setShowDropdown(false);
  };

  const handleLinkClick = (idx: number) => {
    handleTabChange(items[idx].id);
  };

  useEffect(() => {
    const sectionId = location?.hash.substring(1);
    if (sectionId) {
      if (items.find(item => item.id === sectionId)) {
        handleTabChange(sectionId);
      }
    }
  }, []);

  return (
    <div className={styles.navContainer}>
      <div className={styles.navBar}>
        {shouldCollapseNav ? (
          <ListDropdown
            anchorElement={
              <button type="button" className={styles.navAnchor} onClick={() => setShowDropdown(showDropdown)}>
                <span className={styles.navTitle}>{title}</span>
                <Chevron size="sm" orientation={showDropdown ? 'up' : 'down'} color={COLOR_INTERACTIVE_SUBTLE} />
              </button>
            }
            links={items.map(item => ({
              label: item.title,
              href: '/',
              dataTestId: item.title
            }))}
            handleLinkClick={handleLinkClick}
            isDropdownOpen={showDropdown}
            setIsDropdownOpen={(isOpen: boolean) => setShowDropdown(isOpen)}
          />
        ) : (
          <>
            <span className={styles.navTitle}>{title}</span>
            <TabBar
              activeTab={selectedTab}
              className={styles.tabBar}
              hideBottomBorder
              onChange={handleTabChange}
              tabs={items.map(item => ({
                id: item.id,
                label: item.title,
                testId: item.title
              }))}
              testId="scroller-nav-tab-bar"
            />
          </>
        )}
        {ctaInfo && (
          <div className={styles.ctaButton}>
            <Button text={ctaInfo.title} className={styles.ctaButton} onClick={ctaInfo.onClick} testId={ctaInfo.title} variant="primary" />
          </div>
        )}
      </div>
    </div>
  );
};

export default ScrollerNav;
